import { render } from "./SetupWizard.vue?vue&type=template&id=7e08dd58&scoped=true"
import script from "./SetupWizard.vue?vue&type=script&lang=js"
export * from "./SetupWizard.vue?vue&type=script&lang=js"

import "./SetupWizard.vue?vue&type=style&index=0&id=7e08dd58&scoped=true&lang=css"

import exportComponent from "C:\\Github\\dev-mynet\\Products\\Hub\\web\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e08dd58"]])

export default __exports__